import { t } from 'i18next';
import { Component } from 'react';
import ManualClusterSelect from '../../../components/manualClusterModal';

class AdditionalBox extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-additional-view">
                    <div className="box-with-switch gap-10 d-flex align-items-center">
                        <div className="d-flex">
                            <div className="switch-container">
                                <button
                                    className={`switch-button ${
                                        this.props.toggle ? 'active' : 'not-active'
                                    }`}
                                    onClick={() => this.props.onToggle(!this.props.toggle)}
                                >
                                    <span className="switch-circle"></span>
                                </button>
                            </div>
                            <div>
                                {' '}
                                <i
                                    title={t(
                                        'search.evergreen.additionalBox.high_potential_tooltip',
                                    )}
                                    className="icon-info cursor-pointer"
                                    style={{ marginLeft: '7px' }}
                                ></i>{' '}
                                {t('search.evergreen.additionalBox.high_potential')}
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="switch-container">
                                <button
                                    className={`switch-button ${
                                        this.props.isOptimiz ? 'active' : 'not-active'
                                    }`}
                                    onClick={() => this.props.optimiz()}
                                >
                                    <span className="switch-circle"></span>
                                </button>
                            </div>
                            <div>
                                <i
                                    title="Only show evergreen articles that need to be optimized"
                                    className="icon-info cursor-pointer"
                                    style={{ marginLeft: '7px' }}
                                ></i>{' '}
                                {t('search.evergreen.additionalBox.optimization_recommended')}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div>
                            <ManualClusterSelect
                                current_url={this.props.endpoint_url}
                                csrf_token={this.props.csrf_token}
                                selectedItems={this.props.selectedItems}
                                cluster_type="url"
                                header={t('search.evergreen.additionalBox.add_to_urls_list')}
                                onRemoveAllSelected={this.props.onRemoveAllSelected}
                            />
                        </div>
                        <div className="ml-10">
                            <a href="/domains/get-user-domains/" className="add-cluster-btn">
                                {t('search.evergreen.additionalBox.see_ignored_urls')}
                            </a>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AdditionalBox;
